import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { API_STATUSES } from '../constants';

interface IProps {
    status: string;
    nonBtnFeedback?: boolean;
}

const TRANSIENT_STATUSES: string[] = [API_STATUSES.ERROR, API_STATUSES.SUCCESS];
const TRANSIENT_ELEM_DURATION = 10 * 1000; // 10secs.

const InlineFeedback = ({ status, nonBtnFeedback = false }: IProps) => {
    const [visible, setVisible] = useState(true);
    const timer = useRef(null);

    useEffect(() => {
        setVisible(true);

        if (TRANSIENT_STATUSES.includes(status) === false) {
            return;
        }

        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(
            () => setVisible(false),
            TRANSIENT_ELEM_DURATION
        );
        return () => clearTimeout(timer.current);
    }, [status]);

    if (!visible) {
        return <></>;
    }

    const classes = ['inline-feedback', { 'non-btn-feedback': nonBtnFeedback }];

    switch (status) {
        case API_STATUSES.IN_PROGRESS:
            return <div className={classNames('ar-spinner', ...classes)} />;
        case API_STATUSES.SUCCESS:
            return (
                <i
                    className={classNames('fas', 'ar-icon-success', ...classes)}
                />
            );
        case API_STATUSES.ERROR:
            return (
                <i
                    className={classNames('fas', 'ar-icon-danger', ...classes)}
                />
            );
        default:
            return <></>;
    }
};

export default InlineFeedback;
